import Vue from 'vue'
import vuex from "vuex";
import App from './App.vue'
import 'ant-design-vue/dist/antd.css';
import router from '@/router/index'
import Video from 'video.js'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'videojs-flash'

Vue.use(VueVideoPlayer);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
const echarts = require('echarts');

import Antd from 'ant-design-vue';
Vue.use(Antd);

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
	/* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
	ak: 'duMFf60CKIoUX3LjUfSWU7uM6zfVUiN8'
})

import request from '../src/utils/request';
Vue.prototype.request = request;

new Vue({
	el: '#app',
	router,
	render: h => h(App)
})
